const ClickableImage = (props: any): JSX.Element => <img role="presentation" alt="" {...props} />;

export default ClickableImage;
